import { Injectable, inject } from '@angular/core';
import { DEAL_CONFIRMED, TableKey } from '@tradecafe/types/core';
import { switchMap } from 'rxjs/operators';
import { DealElasticSearchService } from 'src/services/data/deal-elastic.service';
import { ModalService } from 'src/shared/modal';
import { InventoryDealsFormComponent, InventoryDealsFormOptions } from './inventory-deals-form.component';

@Injectable()
export class InventoryDealsFormService {
  private modal = inject(ModalService)
  private elastic = inject(DealElasticSearchService)


  show(opts: InventoryDealsFormOptions) {
    const payload = {
      sort: [{ deal_id: 'desc' }],
      columns: [
        'deal_id',
        'container_number',
        'supplier',
        'origin_location',
        'buying_trader',
        'shipment_date',
      ],
      query: {
        product: [opts.product],
        status: [DEAL_CONFIRMED],
        deal_type: "bwi",
        convertible: true,
      },
      skip: 0,
      limit: 10,
      calculate: false,
      populate_intransit_balance: false,
    }

    return this.elastic.fetchDeals(payload, TableKey.DealInventory)
      .pipe(switchMap(res => {
        return this.modal.openDialog(InventoryDealsFormComponent, opts, {
          panelClass: ['tc-dialog', 'modal-xlg'],
          width: null,
          maxWidth: null,
        })
      }))
  }
}
